import {
  createRouterMiddleware,
  createRouterReducer,
  ReduxRouterSelector,
} from "@lagunovsky/redux-react-router";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { reducer as formReducer } from "redux-form";
import thunk from "redux-thunk";

import {
  authReducer,
  bulkyItemsTypesReducer,
  categoryTypesReducer,
  citySettingsReducer,
  notificationsReducer,
  periodTypesReducer,
  bulkItemsSchedulerReducer,
} from "./reducers";
import { history } from "./services";

const router = createRouterMiddleware(history);

const reducer = combineReducers({
  navigator: createRouterReducer(history),
  form: formReducer,
  auth: authReducer,
  notifications: notificationsReducer,
  citySettings: citySettingsReducer,
  categoryTypes: categoryTypesReducer,
  bulkyItemsTypes: bulkyItemsTypesReducer,
  periodTypes: periodTypesReducer,
  bulkyItemsScheduler: bulkItemsSchedulerReducer,
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).prepend(thunk, router),
  devTools: process.env.NODE_ENV !== "production",
});

export type AppState = ReturnType<typeof store.getState>;

export const routerSelector: ReduxRouterSelector<AppState> = (state) => state.navigator;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
